const API_URL = "https://trending-api.nakamotodaily.com/v1"

const defaultArticle = {
    title: '',
    reading_time: 0,
    authors: [
        {name: ""}
    ],
    tags: [
        {name: "", url: "/"},
        {name: "", url: "/"},
        {name: "", url: "/"},
    ]
}

const insertArticles = (articles, cardTemplate, container, loading = false) => {
    if (articles.length === 0) {
        const emptyText = document.createElement("p")
        emptyText.innerText = "No articles here yet"
        container.appendChild(emptyText)
    }
    articles.map((article) => {
        const template = cardTemplate.content.cloneNode(true)
        if (loading) template.children[0].classList.add("loading")

        const title = template.querySelector(".card-title")
        if (!title) return
        title.innerText = article.title

        const tagsContainer = template.querySelector(".card-tags")
        if (!tagsContainer) return
        article.tags.map((tag) => {
            const el = document.createElement("a")
            el.href = tag.url
            el.innerText = tag.name
            tagsContainer.appendChild(el)
        })

        template.querySelectorAll("article > a, .card-link").forEach((el) => {
            el.href = article.url
        })

        const authorsContainer = template.querySelector(".card-authors")
        if (!authorsContainer) return
        authorsContainer.innerText = article.authors.map((author) => author.name).join(", ")

        const timeContainer = template.querySelector(".card-reading-time")
        if (!timeContainer) return
        timeContainer.innerText = `${article.reading_time} ${article.reading_time === 1 ? "min" : "mins"}`

        container.append(template)
    })
}

const fetchArticles = async () => {
    const trendingContainer = document.querySelector("[data-trending-articles]")
    const trendingTemplate = document.querySelector("[data-trending-template]")
    if (!trendingContainer || !trendingTemplate) return
    insertArticles(new Array(4).fill(defaultArticle), trendingTemplate, trendingContainer, true)

    const trendingArticlesRes = await fetch(`${API_URL}/trending`)
    let trendingArticles = await trendingArticlesRes.json()
    trendingArticles = trendingArticles.slice(0, 8)
    trendingContainer.innerHTML = ''
    insertArticles(trendingArticles, trendingTemplate, trendingContainer)

}

export default fetchArticles
